import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import {
  deviceDetailsSlice,
  DeviceDetailsState,
  tabAlertsToggleIsSidebarFilterOpenAction,
  tabAttacksToggleIsSidebarFilterOpenAction,
  tabLogsToggleIsFiltersPanelOpen,
} from './deviceDetails.slice';

export const deviceDetailsMiddleware: Middleware = (api) => (next) => (action) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const actionType = action?.type as string;
  const deviceStateBeforeAction = api.getState()?.[deviceDetailsSlice.name];

  if (deviceStateBeforeAction) {
    // NOTE: Middleware is executed BEFORE given action
    deviceMiddlewaresBeforeAction[actionType]?.(deviceStateBeforeAction);
  }

  const result = next(action);
  const deviceStateAfterAction = api.getState()?.[deviceDetailsSlice.name];

  if (deviceStateAfterAction) {
    // NOTE: Middleware is executed AFTER given action
    deviceMiddlewaresAfterAction[actionType]?.(deviceStateAfterAction);
  }

  return result;
};

type MiddlewareCallback = (state: DeviceDetailsState) => unknown;

const deviceMiddlewaresBeforeAction: Record<string, MiddlewareCallback> = {};

const deviceMiddlewaresAfterAction: Record<string, MiddlewareCallback> = {
  [tabAlertsToggleIsSidebarFilterOpenAction.type]: (state: DeviceDetailsState) => {
    appStorage.deviceDetails.setIsSidebarFilterOpenForTabAlerts(state.tabAlerts.isSidebarFilterOpen);
  },

  [tabAttacksToggleIsSidebarFilterOpenAction.type]: (state: DeviceDetailsState) => {
    appStorage.deviceDetails.setIsSidebarFilterOpenForTabAttacks(state.tabAttacks.isSidebarFilterOpen);
  },

  [tabLogsToggleIsFiltersPanelOpen.type]: (state: DeviceDetailsState) => {
    appStorage.device.setIsSidebarFilterOpenForTabLogs(state.tabLogs.isFiltersPanelOpen);
  },
};
